import React from 'react';
import { SimpleGrid, Box } from '@hover/blueprint';
import TrustedContent from './TrustedContent';
import { TrustedByNamesSlide } from '../../common';

const TrustedByNamesDesktop: React.FC = () => (
  <Box d={{ base: 'none', desktop: 'flex' }} w="100%" px={500} py={1100}>
    <SimpleGrid w="100%" columns={2} spacing={1000} alignItems="center">
      <Box h="480px">
        <TrustedByNamesSlide />
      </Box>
      <Box>
        <TrustedContent />
      </Box>
    </SimpleGrid>
  </Box>
);

export default TrustedByNamesDesktop;
